/*==============================================================*/
//accordion  - START CODE
/*==============================================================*/
$(document).on("click", '.accordion-style .panel-heading a', function (e) {
	e.preventDefault();
});

$('.accordion-style .collapse').on('show.bs.collapse', function () {
	var id = $(this).attr('id');
	$('a[href="#' + id + '"]').closest('.panel-heading').addClass('active-accordion');
	$('a[href="#' + id + '"] .panel-title span').html('<i class="sgr-icon-minus"></i>');
});

$('.accordion-style .collapse').on('hide.bs.collapse', function () {
	var id = $(this).attr('id');
	$('a[href="#' + id + '"]').closest('.panel-heading').removeClass('active-accordion');
	$('a[href="#' + id + '"] .panel-title span').html('<i class="sgr-icon-plus"></i>');
});


// WEBPACK FOOTER //
// ./scripts/elements/_accordion.js